import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { DEFAULT_USER_AVATAR } from "../utils/userAvatar";
import styles from "./index.module.less";

export default function UserAvatar({ src, size = 28, className, alt = "" }) {
  const [failed, setFailed] = useState(false);
  const resolvedSrc = failed || !src ? DEFAULT_USER_AVATAR : src;

  useEffect(() => {
    setFailed(false);
  }, [src]);

  return (
    <img
      src={resolvedSrc}
      alt={alt}
      width={size}
      height={size}
      className={classNames(styles.userAvatarImg, className)}
      onError={() => setFailed(true)}
    />
  );
}
